import generateApiFun, { apiConfig } from './../generate'

const list: apiConfig = {
  // 获取数据
  getTableRows: {
    url: '/v1/chain/get_table_rows',
    method: 'post',
    host: 'amaxNodeApi'
  },
  getRealIdInitialize: {
    url: '/did/api/initialize',
    method: 'post',
    host: 'centralizedApi'
  },
  getCompareInitializeApi: {
    url: '/did/api/compare/initialize',
    method: 'post',
    host: 'compareApi'
  },
  getCompareRecoverApi: {
    url: '/did/api/compare/initRecover',
    method: 'post',
    host: 'compareApi'
  },
  getCompareCheck: {
    url: '/did/api/compare/check',
    method: 'post',
    host: 'compareApi'
  },
  getRecoverRecords: {
    url: '/did/api/compare/orders',
    method: 'post',
    host: 'centralizedApi'
  },
  getCheck: {
    url: '/did/api/check',
    method: 'post',
    host: 'centralizedApi'
  },
  getOrderErrorMsg: {
    url: '/did/api/getOrderErrorMsg',
    method: 'get',
    host: 'centralizedApi'
  }

}
const mainAllApi = generateApiFun(list)

export default mainAllApi
